import reducers from './reducers';

export {
    actions as infoOperations,
    default as infoSaga,
} from './operations';

export default reducers;
